<template>
  <table-blue :cols="cols">
    <tr class="odd">
      <td style="text-align:center;"><strong>{{ $t('td.transfers') }}</strong></td>
      <td><strong>{{ convertedCashIn }}</strong></td>
      <td><strong>{{ convertedCashOut }}</strong></td>
      <td><strong>{{ convertedCashInOut }}</strong></td>
    </tr>
  </table-blue>
</template>

<script>
  import utils from '../../../../utils';
  import TableBlue from './TableBlue';
  import { mapGetters } from 'vuex';
  export default {
    name: "TableBlueSummary",
    props: ['cashIn', 'cashOut'],
    components: {
      TableBlue,
    },
    data() {
      return {
        cols: [
          { i18n: '',             align: 'center' },
          { i18n: 'th.cashIn',    align: 'right' },
          { i18n: 'th.cashOut',   align: 'right' },
          { i18n: 'th.cashInOut', align: 'right' },
        ]
      }
    },
    computed: {
      ...mapGetters(['currency']),
      coinIn() {
        return this.transactions
          .filter(item => item.action === 'DEPOSIT' || item.action === 'CREATE')
          .map(item => item.amount)
          .reduce((c, n) => c + n, 0);
      },
      coinOut() {
        return this.transactions
          .filter(item => item.action === 'WITHDRAW' || item.action === 'REMOVE')
          .map(item => item.amount)
          .reduce((c, n) => c + n, 0);
      },
      coinInOut() {
        return this.coinIn - this.coinOut;
      },
      convertedCashIn() {
        return utils.convertSystemToCurrency(this.cashIn, this.currency);
      },
      convertedCashOut() {
        return utils.convertSystemToCurrency(this.cashOut, this.currency);
      },
      convertedCashInOut() {
        return utils.convertSystemToCurrency(this.cashIn - this.cashOut, this.currency);
      }
    }
  }
</script>

<style scoped>
  td {
    text-align: right;
  }
</style>
